
  <div mwlResizable [enableGhostResize]="true" [resizeEdges]="{right: true }" (resized)="onResized($event)"
       [ngStyle]="{'width': width > 0 ? width + 'px':'100px'}"  (mousedown)= "resizeColumn($event)">
        <div> {{tile}}</div>
  </div>
